import {
  IChatbotFlowModel,
  IChatbotSessionModel,
} from '../data/models/chatbot';
import { IFlowModel } from '../data/models/flow';

export function flowToChatbotMapper(flow: IFlowModel): IChatbotFlowModel {
  const fluxObjectNode = flow.nodes?.find(
    (item: any) => item.type === 'fluxObject',
  );

  const sessions: IChatbotSessionModel[] =
    fluxObjectNode?.data?.userSessionsChat ?? [];

  return {
    id: flow.id,
    name: flow.name,
    public: flow.public,
    description: flow.description,
    backgroundColor: flow.backgroundColor,
    logo: flow.logo,
    chatImage: flow.chatImage,
    chatDescription: flow.chatDescription,
    chatActions: flow.chatActions,
    chatbotDropdowns: flow.chatbotDropdowns ?? [],
    chatbotVoiceModel: flow.chatbotVoiceModel,
    chatbotVoice: flow.chatbotVoice,
    chatbotDataInputNodeId: flow.chatbotDataInputNodeId,
    chatbotDataOutputNodeId: flow.chatbotDataOutputNodeId,
    sessions,
    favicon: flow.favicon,
    iconShape: flow.iconShape,
    iconSize: flow.iconSize,
    autoOpenChatbotOnLoad: flow.autoOpenChatbotOnLoad,
    disableFluxpromptBranding: flow.disableFluxpromptBranding,
    defaultTheme: flow.defaultTheme,
    brandColor: flow.brandColor,
    inputBorderColor: flow.inputBorderColor,
    font: flow.font,
    fontWeight: flow.fontWeight,
    pageBackground: flow.pageBackground,
    pageText: flow.pageText,
    backgroundImage: flow.backgroundImage,
    responseContainer: flow.responseContainer,
    responseText: flow.responseText,
    userContainer: flow.userContainer,
    userText: flow.userText,
    placeholder: flow.placeholder,
    firstMessage: flow.firstMessage,
    storeOpeningMessage: flow.storeOpeningMessage,
    enableChatFlyout: flow.enableChatFlyout ?? null,
    flyoutPosition: flow.flyoutPosition ?? null,
    contentSource: flow.contentSource ?? null,
    flyOutDataOutputNodeId: flow.flyOutDataOutputNodeId ?? null,
    image: flow.image ?? null,
    code: flow.code ?? null,
    audio: flow.audio ?? null,
    websites: flow.websites ?? null,
    flyOutContents: flow.flyOutContents ?? null,
  };
}
